import GetHydrantMapItemsListRequestModelBase from '../_generated/modelBases/get-hydrant-map-items-list-request-model-base';

export default class GetHydrantMapItemsListRequestModel extends GetHydrantMapItemsListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
